/* eslint-disable */
import Component from 'gia/Component'
export default class componentAccordions extends Component {
  constructor(element) {
    super(element)
  }

  accordions() {
    $(this.element.querySelectorAll('.accordions__wrapper')).each(function() {
      $('.accordion-single__content').hide()
      $(this)
        .find('.accordion-single__header a')
        .click(function(e) {
          e.preventDefault()
          $(this)
            .closest('.accordion-single__header')
            .siblings('.accordion-single__content')
            .slideToggle()
          $(this)
            .closest('.accordion-single__header')
            .toggleClass('active')
        })
    })
  }

  mount() {
    this.accordions()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Accordions.js